import { ColumnConfig } from '../types.js'
import { GutterButton } from './gutter-button.js'
import { GutterDirty } from './gutter-dirty.js'
import { GutterRowSelector } from './gutter-row-selector.js'
import { GutterSequence } from './gutter-sequence.js'

var GUTTERS: { [name: string]: any } = {
  sequence: GutterSequence,
  'row-selector': GutterRowSelector,
  button: GutterButton,
  dirty: GutterDirty
}

export function registerGutter(name: string, gutter: any) {
  GUTTERS[name] = gutter
}

export function unregisterGutter(name: string) {
  delete GUTTERS[name]
}

export function getGutters() {
  return { ...GUTTERS }
}

export const generateGutterColumn = (config: ColumnConfig) => {
  var clazz = GUTTERS[config.gutterName || '']

  if (clazz) {
    return clazz.instance(config)
  }
}
